/**
 * 이모 수첩 적기 시트 (시안 13 N2 · N5 · N6, C-31 · D75). 앱 어디서나 하나(App 의 NoteSheetHost).
 * 나 탭 · 1:1 수첩 시트 · 내 말 길게 누르기에서 open 으로 엽니다. 적으면 lastSaved 가 바뀌어 수첩 화면이 다시 읽습니다.
 */
import { create } from 'zustand';

export const useNoteSheet = create((set) => ({
    // { entry, draft?, fixedMember?, origin?: { messageId, surface, memberKey? }, editing?: memory, onSaved? }
    request: null,
    lastSaved: null,
    open(request) {
        set({ request });
    },
    close() {
        set({ request: null });
    },
    saved(note) {
        set({ request: null, lastSaved: { memoriesId: note.memoriesId, at: Date.now() } });
    },
}));
